import { render, staticRenderFns } from "./AxListPanel.vue?vue&type=template&id=1461eb64&scoped=true"
import script from "./AxListPanel.vue?vue&type=script&lang=ts"
export * from "./AxListPanel.vue?vue&type=script&lang=ts"
import style0 from "./AxListPanel.vue?vue&type=style&index=0&id=1461eb64&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1461eb64",
  null
  
)

export default component.exports